import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=c0a9b4fe&scoped=true&"
import script from "./accounts.vue?vue&type=script&lang=js&"
export * from "./accounts.vue?vue&type=script&lang=js&"
import style0 from "./accounts.vue?vue&type=style&index=0&id=c0a9b4fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a9b4fe",
  null
  
)

export default component.exports